export const AppNextLogoMark = (props) => (
  <svg
    style={{ ...props?.style }}
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.51367 21.3001L1.54639 27.5167C1.56275 29.2344 2.95331 30.6086 4.6547 30.5923L10.8386 30.5596L6.17613 25.9298L1.51367 21.3001ZM30.4864 10.5682L30.4537 4.35161C30.4373 2.63386 29.0467 1.25966 27.3453 1.27602L21.1451 1.30874L25.8239 5.93849L30.4864 10.5682Z'
      fill='#F0B44B'
    />
    <path
      d='M27.5245 30.4614C29.2259 30.445 30.6001 29.0545 30.5837 27.3367L30.551 21.1201L21.3242 30.5105L27.5245 30.4614Z'
      fill='#4EADA6'
    />
    <path
      d='M1.02227 13.8397C-0.171973 15.0666 -0.155614 17.0134 1.05499 18.224L5.4557 22.592L5.3739 9.40625L1.02227 13.8397Z'
      fill='#DE5E48'
    />
    <path
      d='M9.49538 26.6166L13.8961 30.9846C15.1067 32.1788 17.0535 32.1788 18.2641 30.9519L22.6157 26.5184L16.0555 26.5675L9.49538 26.6166ZM22.4848 5.26744L18.0841 0.899447C16.8735 -0.294797 14.9104 -0.294797 13.7161 0.932166L9.38086 5.34923L15.941 5.30016L22.4848 5.26744Z'
      fill='#3E92D0'
    />
    <path
      d='M30.9437 13.6439L26.543 9.27588L26.6248 22.4617L30.9764 18.0282C32.1543 16.8176 32.1543 14.8545 30.9437 13.6439Z'
      fill='#DE5E48'
    />
    <path
      d='M4.47344 1.40699C2.77205 1.42335 1.39785 2.81391 1.41421 4.53166L1.44693 10.7483L10.6737 1.35791L4.47344 1.40699Z'
      fill='#4EADA6'
    />
  </svg>
);
